import img2 from "../../images/forage2.jpg";
import drop from "../../images/icons/drop.png";
import calendar from "../../images/icons/calendar.png";
import robine from "../../images/icons/robiné.png";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../ui/carousel";
import IconsList3 from "./IconsList3";

const WaterResult = () => {
  const images = [
    { id: 1, img: img2 },
    {
      id: 2,
      img: img2,
    },
  ];
  return (
    <>
      <div>
        <div className="container mx-auto mt-20 mb-20 ">
          <div className="grid items-center gap-5 mt-10 mb-10 md:grid-cols-2">
            <div className="">
              <h2 className="font-black text-left text-black ">Collecteurs</h2>
              <p className="mt-2 text-left">
                En sortie de chaque habitation, les eaux usées sont recueillies
                et canalisées dans des collecteurs (l'ensemble forme le réseau
                d'égouts), puis acheminées jusqu'à l'usine de traitement des
                eaux de Carré de Réunion en utilisant l'inclinaison naturelle du
                terrain ou à l'aide de stations de pompage intermédiaires.
              </p>
              <div>
                <p className="mt-5 font-bold text-black">
                  Il existe deux types de réseaux de collecte :
                </p>
                <ul className="mt-5 ml-5 list-disc">
                  <li>
                    Le réseau "séparatif" : permet de collecter dans deux
                    canalisations distinctes les eaux usées issues des
                    utilisations domestiques de l'eau potable (WC, salle de
                    bains, cuisine, buanderie…), et les eaux pluviales (eaux de
                    ruissellement et toitures, de surverse de mare, de
                    drainage…).
                  </li>
                  <li>
                    Le réseau "unitaire" : un seul collecteur recueille les deux
                    types d'eau.
                  </li>
                </ul>
                <p className="mt-5">
                  Environ 14 millions de mètres cubes d'eau empruntent ainsi
                  tous les ans un réseau de canalisation long de 44 km. Ce
                  réseau s'appuie sur des infrastructures anciennes et
                  prestigieuses puisqu'elles doivent leur existence à la
                  construction du château de Versailles et de ses dépendances.
                  Les deux collecteurs principaux datent ainsi des XVIIe et
                  XVIIIe siècles. Il fait l'objet d'un entretien et d'un suivi
                  permanent.
                </p>
              </div>
            </div>

            <div className="max-w-6xl px-4 mx-auto ">
              <Carousel
                opts={{ align: "start", loop: true }}
                className="w-full"
              >
                <CarouselContent>
                  {images.map((item) => (
                    <CarouselItem key={item.img}>
                      <div className="flex items-center justify-center w-full bg-gray-200 rounded-lg h-80">
                        <img
                          src={item.img}
                          alt=""
                          className="object-cover w-full h-full rounded-lg"
                        />
                      </div>
                    </CarouselItem>
                  ))}
                </CarouselContent>
                <CarouselPrevious className="absolute flex items-center justify-center border-none text-white transform -translate-y-1/2 bg-teal-500 rounded-full left-4 top-1/2 hover:bg-teal-600" />
                <CarouselNext className="absolute flex items-center justify-center border-none text-white transform -translate-y-1/2 bg-teal-500 rounded-full right-4 top-1/2 hover:bg-teal-600" />
              </Carousel>
            </div>
          </div>
        </div>
        <IconsList3
          headingTitle=""
          title1="d'eau par an"
          val1="14 millions de m³"
          img1={drop}
          title2="des collecteurs datent du"
          val2="XVIIe siècle"
          img2={calendar}
          title3="de réseau de canalisation"
          val3="44 km"
          img3={robine}
        />
      </div>
    </>
  );
};

export default WaterResult;
